module.exports = __webpack_public_path__ + "static/media/exambly-mockup-for-website.2d05dc68.png";